export default __webpack_public_path__ + "static/media/secrets.037b129a.jpg";